// extracted by mini-css-extract-plugin
export default {"wave":"Wave-module--wave--p5clZ"};